module.exports = __webpack_public_path__ + "static/media/barcode-scan.c3a46502.svg";